module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("56hY4"))).then(() => parcelRequire('5tqIs'));